import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=0f01fc0a&scoped=true&"
import script from "./pass.vue?vue&type=script&lang=js&"
export * from "./pass.vue?vue&type=script&lang=js&"
import style0 from "./pass.vue?vue&type=style&index=0&id=0f01fc0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f01fc0a",
  null
  
)

export default component.exports